import ExperienceLocation from 'components/Happening/ExperienceLocation/ExperienceLocation';

export default ExperienceLocation;
